import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import * as siteManagementService from '../../../services/siteManagementService'
import styles from '../../../pages/Home/ManageSiteAttachments/ManageSiteAttachments.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faSquareCheck, faSquareXmark } from '@fortawesome/free-solid-svg-icons'

// image elements
const pencil = <FontAwesomeIcon icon={faPencil} />
const squareCheck = <FontAwesomeIcon icon={faSquareCheck} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} />

const ManageAttachment = ({ index, attachment, attachmentTypes, editAttachment, cancelEdit, editingId, getBase64 }) => {
    const navigate = useNavigate()
    const [attachmentFile, setAttachmentFile] = useState();
    const [formData, setFormData] = useState(
        {
            id: null,
            fileName: null,
            fileExtension: null,
            fileType: null,
            displayName: null,
            description: null,
            attachmentType: null,
            attachmentTypeName: null,
            attachmentBase64: null,
        }
    )
    const generatePDF = (attachment) => {
        if (formData.attachmentBase64) {
            let newPDF = createObjectURLfromBase64(formData.attachmentBase64, formData.fileType);
            window.open(newPDF);
        }
        else {
            return null
        }

    }
    useEffect(() => {
        setFormData(attachment);
        setAttachmentFile(createObjectURLfromBase64(attachment.attachmentBase64, attachment.fileType));
        if (attachment.attachmentTypeName && attachment.attachmentTypeName.length > 0) {
            // try to set client, for event retreval, may not work due to object setting/timing
            var foundType = attachmentTypes.find((item) => item.name === attachment.attachmentTypeName);
            if (foundType) {
                formData.attachmentType = foundType;
                formData.attachmentTypeName = foundType.name;
            }
            else {
                formData.attachmentType = null;
                formData.attachmentTypeName = null;
            }
        }
    }, [])
    async function handleFileChange(e) {
        //https://stackoverflow.com/questions/39092859/get-dimensions-of-image-with-react
        let fileName = e.target.files[0].name;
        const fileAndExtension = fileName.split('.');
        formData.fileName = fileAndExtension[fileAndExtension.length - 2];
        formData.fileExtension = fileAndExtension[fileAndExtension.length - 1];
        formData.fileType = e.target.files[0].type;
        setAttachmentFile(URL.createObjectURL(e.target.files[0]));
        formData.attachmentBase64 = await getBase64(e.target.files[0]);
    }
    const handleChange = (e) => {

        if (e.target.type === 'select-one') {
            var foundType = attachmentTypes.find((item) => item.name === attachment.attachmentTypeName);
            if (foundType) {
                setFormData({
                    ...formData,
                    ['attachmentType']: foundType,
                    ['attachmentTypeName']: foundType.name,
                })
            }
            else {
                setFormData({
                    ...formData,
                    ['attachmentType']: null,
                    ['attachmentTypeName']: null,
                })
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    const createSaveRequest = (items) => {
        let fieldsSave = {};
        if (formData.id) {
            fieldsSave = {
                'id': formData.id,
                'fileName': formData.fileName,
                'fileType': formData.fileType,
                'fileExtension': formData.fileExtension,
                'displayName': formData.displayName,
                'description': formData.description,
                'attachmentTypeName': formData.attachmentTypeName,
                'attachmentBase64': formData.attachmentBase64,
            }
        }
        else {
            fieldsSave = {
                'fileName': formData.fileName,
                'fileType': formData.fileType,
                'fileExtension': formData.fileExtension,
                'displayName': formData.displayName,
                'description': formData.description,
                'attachmentTypeName': formData.attachmentTypeName,
                'attachmentBase64': formData.attachmentBase64,
            }
        }
        return fieldsSave
    }

    const isEditInvalid = () => {
        return !(formData.fileName && formData.fileExtension && formData.attachmentTypeName);
    }
    const submitEdit = async e => {
        e.preventDefault()
        let saverequest = createSaveRequest();
        try {
            await siteManagementService.editAttachment(saverequest)
            navigate('/ManageSiteAttachments')
        } catch (err) {
            console.log(err)
        }

    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        const cleanBase64 = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
        const byteCharacters = atob(cleanBase64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    function createObjectURLfromBase64(base64String, contentType) {
        const blob = base64ToBlob(base64String, contentType);
        return URL.createObjectURL(blob);
    }

    return (
        <>
            {editingId !== index.toString() ?
                <tr className = {styles.trAttachments}>
                    <td className={styles.tdAttachments}> {formData.fileName}</td>
                    <td className={styles.tdAttachments}> {formData.fileExtension}</td>
                    <td className={styles.tdAttachments}> {formData.displayName}</td>
                    <td className={styles.tdAttachments}> {formData.description}</td>
                    <td className={styles.tdAttachments}> {formData.attachmentTypeName}</td>
                    <td className={styles.tdAttachments}>
                        <a title={formData.description} className={styles.pdfLink}
                        onClick={() => generatePDF(formData.pdfAttachment)}> Press Here</a>
                    </td>
                    <td className={styles.tdAttachments}>
                        <button className={styles.editButton} onClick={e => editAttachment(e)} id={index} title="Edit attachment.">
                            <i className={styles.buttonImage}>{pencil}</i>
                        </button>
                    </td>
                </tr>
                :
                <tr className={styles.trAttachments}>
                    <td className={styles.tdAttachments}>
                        <label name="fileName" >{formData.fileName}</label>
                    </td>
                    <td className={styles.tdAttachments}>
                        <label name="fileExtension" >{formData.fileExtension}</label>
                    </td>
                    <td className={styles.tdAttachments}>
                        <input
                            type="text"
                            value={formData.displayName}
                            name="displayName"
                            onChange={handleChange}
                        />
                    </td>
                    <td className={styles.tdAttachments}>
                        <input
                            type="text"
                            value={formData.description}
                            name="description"
                            onChange={handleChange}
                        />
                    </td>
                    <td className={styles.tdAttachments}>
                        <select
                            name="attachmentTypeName"
                            id={styles.ThirdPartyListDropdown}
                            value={formData.attachmentTypeName}
                            onChange={handleChange}
                        >
                            <option disabled={true} value="" selected="selected">
                                -- Select an option --
                            </option>
                            {
                                attachmentTypes.map((ci, idx) => (
                                    <option key={idx}>{ci.name}</option>
                                ))
                            }
                        </select>
                    </td>
                    <td className={styles.tdAttachments}>
                        <input type="file" onChange={handleFileChange} name="attachmentFile" />
                        <label>Preview</label>
                        <div>
                            <iframe src={attachmentFile} type={formData.fileType}></iframe>
                        </div>
                        
                    </td>
                    <td className={styles.tdAttachments}>
                        <button onClick={e => cancelEdit(e)} id={index} className={styles.editButtons} title="Cancel Edit">
                            <i className={styles.buttonImage} id={styles.editCancel}>
                                {squareXmark}
                            </i>
                        </button>
                        <button onClick={e => submitEdit(e)} id={index} className={styles.editButtons} disabled={isEditInvalid()} title="Submit Edit">
                            <i className={styles.buttonImage} id={styles.editSubmit}>
                                {squareCheck}
                            </i>
                        </button>
                    </td>
                </tr>
            }


        </>
    );
}

export default ManageAttachment;
